/* eslint-disable camelcase */
// node modules
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Alert from '@material-ui/lab/Alert';

// app modules: components
import HeadContent from 'components/HeadContent';
import CollectionHero from 'components/Collection/Hero';
import Button from 'components/Button';
import Icon from 'components/Icon';
import Tabs from 'components/Tabs';
import withUserAccessLogger from 'components/UserAccessLogger';

// app modules: props
import CollectionsProps from 'components/Collection/CollectionsProps';

// app modules: services
import { getCollectionCoverImage } from 'services/image';
import route from 'services/route';

// app modules: constants
import CollectionTypes from 'components/Collection/CollectionTypes';
import { COLOURS, CONTENT_TYPES } from '../../constants';

// assets
import CssCollection from './Collection.scss';

class Collection extends Component {
  static propTypes = {
    collection: CollectionsProps.collection,
    type: PropTypes.string,
    asCkbkEditor: PropTypes.bool,
  };

  static defaultProps = {
    collection: null,
    type: null,
    asCkbkEditor: false,
  };

  /**
   * @type {Array.<String>}
   */
  static typesOrder = ['contents', 'books', 'people'];

  static renderEmpty() {
    return (
      <div className="collection__empty margin-top-40">
        <p className="collection__empty__headline">
          To add items to a collection, use
          <Button
            className="collection__empty__button"
            themeType="clear"
            themeName="energized"
            size="large"
            title="Add to collection"
          >
            <Icon fill={COLOURS.ENERGIZED} name="list-add" height="20" width="20" mr={5} />
            Add to collection
          </Button>
        </p>
        <p className="collection__paragraph">
          You can also use the
          <Button
            className="collection__empty__button"
            themeType="clear"
            themeName="energized"
            size="large"
            title="Add to collection"
          >
            <Icon fill={COLOURS.ENERGIZED} name="dots" height="20" width="20" />
          </Button>
          menu on search results
        </p>
      </div>
    );
  }

  types() {
    const { items } = this.props.collection;
    return Collection.typesOrder.filter(type => items[type].length > 0);
  }

  renderTabPanels() {
    const { id, items, can_edit } = this.props.collection;
    const type = this.props.type || this.types()[0] || 'contents';
    const MatrixComponent = CollectionTypes[type].component;

    return (
      <MatrixComponent
        items={items[type]}
        itemWidth={CollectionTypes[type].itemWidth}
        showAll
        itemProps={{ collectionId: can_edit ? id : null, withMenu: true }}
      />
    );
  }

  render() {
    const { collection, type, asCkbkEditor } = this.props;
    const { cover_image, custom_cover_image } = collection;
    const types = this.types();
    const hidden = types.length <= 1 ? 'hidden' : '';
    const image = getCollectionCoverImage(cover_image, custom_cover_image);

    const options = types.map(_type => ({
      label: CollectionTypes[_type].heading,
      id: _type,
      href: route.collection.view(collection, _type === 'contents' ? null : _type),
    }));
    return (
      <div className="collection">
        <HeadContent
          contents={{
            content: image.source,
            width: image.width,
            height: image.height,
            largeImage: image.source,
          }}
        />
        <CollectionHero collection={collection} />
        {asCkbkEditor ? (
          <Alert variant="outlined" className="collection__tablist" severity="info">
            You are using your ckbk editor permissions to view this private collection
          </Alert>
        ) : null}
        {collection?.items_count?.total > 0 ? (
          <Fragment>
            <div className="collection__tablist" hidden={hidden}>
              <Tabs
                className="margin-bottom-20"
                selected={type || types[0] || 'contents'}
                options={options}
                ariaLabel="Content type tabs"
                idPrefix="content-type"
              />
            </div>
            <div className="collection__panels">{this.renderTabPanels()}</div>
          </Fragment>
        ) : (
          Collection.renderEmpty()
        )}
      </div>
    );
  }
}
export default withStyles(CssCollection)(
  withUserAccessLogger(CONTENT_TYPES.COLLECTION, Collection),
);
